import { render } from "./EventCardSkeleton.vue?vue&type=template&id=78e4c6bd&scoped=true"
import script from "./EventCardSkeleton.vue?vue&type=script&lang=js"
export * from "./EventCardSkeleton.vue?vue&type=script&lang=js"

import "./EventCardSkeleton.vue?vue&type=style&index=0&id=78e4c6bd&lang=css&scoped=true"

import exportComponent from "/var/www/mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e4c6bd"]])

export default __exports__